import LanguageService from '../../../shared/LanguageService';
import { markTranslation } from '../../../shared/translationKeyMarkers';
import { findRenderedTranslations } from './renderedTranslations';

type Preview = {
    key: string;
    originalText: string;
    draftText: string;
};

let preview: Preview | null = null;

function replaceShown(key: string, shownText: string, nextText: string) {
    const shown = shownText.trim();
    findRenderedTranslations((rendered) => rendered.key === key && rendered.text === shown).forEach(
        (rendered) => rendered.setText(markTranslation(nextText, key))
    );
}

export function previewTranslation(key: string, draftText: string) {
    const loadedLanguage = LanguageService.getLanguage();
    if (!loadedLanguage) {
        return;
    }

    if (preview === null || preview.key !== key) {
        endTranslationPreview();
        const originalText = loadedLanguage[key];
        preview = {
            key,
            originalText: typeof originalText === 'string' ? originalText : '',
            draftText: typeof originalText === 'string' ? originalText : ''
        };
    }

    replaceShown(key, preview.draftText, draftText);
    preview.draftText = draftText;
    LanguageService.setDraftTranslation(key, draftText);
}

export function endTranslationPreview(): boolean {
    const active = preview;
    preview = null;
    LanguageService.clearDraftTranslation();

    if (active === null) {
        return false;
    }

    replaceShown(active.key, active.draftText, active.originalText);
    return true;
}

export function keepTranslationPreview() {
    preview = null;
    LanguageService.clearDraftTranslation();
}
